import React from 'react'
import styled from 'styled-components'
import { Box } from 'ui-components'
import { Callout, Colors, InputGroup } from '@blueprintjs/core'

type Props = {
  /** String to validate */
  toValidate: string
  /** Amount of characters to validate (default is 5) */
  length?: number
}

const useVerification = (props: Props) => {
  const { toValidate, length = 5 } = props
  const [value, setValue] = React.useState('')
  const firstNs = toValidate.substring(toValidate.length - length).toUpperCase()
  const isValidated = value === firstNs

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value.toUpperCase())
  }

  const handleOnReset = () => {
    setValue('')
  }

  const validator = React.useMemo(() => {
    return (
      <>
        <Box mt="medium" mb="medium">
          <StyledCallout
            $isValidated={isValidated}
            intent={isValidated ? 'success' : 'primary'}
            icon={null}
          >
            <Digits>{firstNs}</Digits>
          </StyledCallout>
        </Box>
        <InputGroup
          large
          value={value}
          onChange={handleOnChange}
          autoFocus={true}
        />
      </>
    )
  }, [firstNs, isValidated, value])

  return {
    validator,
    isValidated,
    handleOnReset,
  }
}

const Digits = styled.div`
  font-size: 30px;
  font-weight: 700;
  text-align: center;
  letter-spacing: 4px;
`

const StyledCallout = styled(Callout)<{ $isValidated: boolean }>`
  transition: background-color 0.5s ease;
  border-style: solid;
  border-width: 1px;
  border-color: ${(props) => {
    return props.$isValidated ? Colors.GREEN1 : Colors.BLUE1
  }};
`

export default useVerification
